import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class PaperflowService {

  constructor(private httpService: HttpService) { }

  getAbsenceByCertificateId(certificateId) {
    const body = {
      'appLang': 'fr',
      'certificateID': certificateId
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/dev/getscancertificatedetailbyid', body)
    return this.httpService.post('/hradmin/getScanCertificateDetailByID', body)
  }

  getScanCertificateList() {
    const body = {
      'appLang': 'fr'
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/dev/getscancertificatelist', body)
    return this.httpService.post('/hradmin/getScanCertificateList', body)
  }

  changeStatus(status, certData) {
    const body = {
      "appLang": "fr",
      "revisionKey": certData.revisionKey.toString(),
      "certificateID": certData.certificateID,
      "recordcreatedby": sessionStorage.getItem('user'),
      "statushradmin": status
    }
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/dev/changestatusscancertificate', body)
    return this.httpService.post('/hradmin/changeStatusScanCertificate', body)
  }

  changeLeaveHistory(employeeID) {
    const body = {
      "appLang": "fr",
      "typeOfLeave": "SickLeave",
      "employeeID": employeeID
    }
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getleavehistoryhra', body)
    return this.httpService.post('/hradmin/getLeaveHistoryHRA', body)
  }

  submitLeave(data) {
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/submitMatchedAbsence', data)
    return this.httpService.post('/hradmin/submitMatchedAbsence', data)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/paperflow.service.ts